import { css } from '@emotion/core'

/**
 * Timings mirror discovery-react's useCategoriesIntro, so arriving at
 * the Activities tab and arriving at an activity feel like the same product.
 */
const ENTER_DURATION_MS = 650
const ENTER_EASE = 'cubic-bezier(0.34, 1.56, 0.64, 1)'

/** Gap between each item starting. 70ms matches the categories grid's 0.07s stagger. */
export const ENTER_STAGGER_MS = 70

/**
 * Rise-and-scale entrance for the Activities tab.
 *
 * The @media here is for prefers-reduced-motion, not a width breakpoint — widths still go through
 * zion's atWidth.
 */
export const enterAnimationCss = css`
  @keyframes together-enter {
    from {
      opacity: 0;
      transform: translateY(28px) scale(0.88);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  opacity: 0;
  animation: together-enter ${ENTER_DURATION_MS}ms ${ENTER_EASE} forwards;
  animation-delay: var(--enter-delay, 0ms);

  @media (prefers-reduced-motion: reduce) {
    opacity: 1;
    animation: none;
  }
`

/** Per-item delay, handed over as a custom property rather than a generated class. */
export const enterDelay = (index) => ({ '--enter-delay': `${index * ENTER_STAGGER_MS}ms` })

/**
 * Entrance for the bottom nav bar, which rises into place rather than scaling with the grid.
 */
export const navEnterAnimationCss = css`
  @keyframes together-nav-enter {
    from {
      opacity: 0;
      transform: translateY(100%);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  opacity: 0;
  animation: together-nav-enter ${ENTER_DURATION_MS}ms ease-out ${ENTER_STAGGER_MS * 2}ms forwards;

  @media (prefers-reduced-motion: reduce) {
    opacity: 1;
    animation: none;
  }
`
